import { Pressable, StyleSheet, Text, View } from 'react-native';

import { Colors } from '@/constants/theme';

interface ErrorFallbackProps {
  onReset: () => void;
}

export function ErrorFallback({ onReset }: ErrorFallbackProps) {
  return (
    <View style={styles.container}>
      <Text style={styles.heading}>Something went wrong</Text>
      <Text style={styles.message}>
        The app ran into an unexpected error. Reloading usually fixes it.
      </Text>
      <Pressable style={styles.button} onPress={onReset}>
        <Text style={styles.buttonText}>Reload App</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.dark.background,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 32,
  },
  heading: {
    fontFamily: 'Georgia, serif',
    fontSize: 28,
    color: Colors.dark.text,
    marginBottom: 12,
    textAlign: 'center',
  },
  message: {
    fontSize: 16,
    color: Colors.dark.textMuted,
    textAlign: 'center',
    lineHeight: 24,
    marginBottom: 32,
  },
  button: {
    backgroundColor: Colors.dark.accent,
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
  },
  buttonText: {
    color: Colors.dark.background,
    fontSize: 16,
    fontWeight: '600',
  },
});
